module.exports = __webpack_public_path__ + "./img-kevin_d89b3be82335c6a0d99d564df5d3a095.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2017/img-kevin.png
// module id = 448
// module chunks = 0